module.exports = __webpack_public_path__ + "img/refresh.b3904cf4.png";